import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import { useSearchParams } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { Helmet } from "react-helmet";
import MainContactForm from "./MainContactForm.jsx";
import CustomerLastShipment from "./CustomerLastShipment";
import CustomerLastShipmentByCustomer from "./CustomerLastShipmentByCustomer";
import CustomerSalesIncharge from "./CustomerSalesIncharge";
import CustomerServiceUsage from "./CustomerServiceUsage";
import CustomerShipperLoadDatagrid from "./CustomerShipperLoadDatagrid";
import AddActivityModal from "../SaleActivity/AddActivityModal";
import CustomerDuplicateDatagrid from "./CustomerDuplicateDatagrid";
import CustomerActivityTimeline from "./CustomerActivityTimeline";
import StageFlow from "./StageFlow";
import { api_path } from "../../shared.js";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
export function CustomerForm(props) {
  const getUserID = JSON.parse(localStorage.getItem("USER_ID"));
  const getEmpCode = JSON.parse(localStorage.getItem("USER_ID"));
  const getUserRole = JSON.parse(localStorage.getItem("USER_ROLE_ID"));
  const [searchParams] = useSearchParams();
  const id = searchParams.get("customer_id") ?? 0;
  const salesId = searchParams.get("salesId") ?? 0;

  const smf_code = searchParams.get("code");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [duplicateData, setDuplicateData] = useState([]);
  const [isDuplicateTax, setIsDuplicateTax] = useState(false);
  const [duplicateTaxData, setDuplicateTaxData] = useState([]);
  const [sharedValue, setSharedValue] = useState("");
  const [getStage, setGetStage] = useState({ label: "Lead" });
  // เก็บค่า SALES_ID และ SALESNAME ที่เลือกจากตาราง
  const [selectedSales, setSelectedSales] = useState({
    SELECT_SALES_ID: "",
    SELECT_SALESNAME: "",
  });
  const handleStageChange = (newStage) => {
    setGetStage({ label: newStage });
  };
  const checkDuplicateName = async (name) => {

  setSearchKeyword(name);
    try {
      const res = await fetch(`${api_path}/customer/check_duplicate_name.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name }),
      });
      const data = await res.json();
      setIsDuplicate(data.duplicate);
      if (data.duplicate) {
        setDuplicateData(data.data || []);
      } else {
        setDuplicateData([]);
      }
    } catch (error) {
      if (typeof console !== "undefined" && console.error) {
        console.error("Error checking duplicate:", error);
      }
    }
  };
  const checkDuplicateTax = async (tax_id) => {
    setSearchKeyword(tax_id);
    try {
      const res = await fetch(`${api_path}/customer/check_duplicate_name.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ tax_id }),
      });
      const data = await res.json();
      console.log(data)
      setIsDuplicateTax(data.duplicate);
      if (data.duplicate) {
        setDuplicateData(data.data || []);
      } else {
        setDuplicateData([]);
      }
    } catch (error) {
      if (typeof console !== "undefined" && console.error) {
        console.error("Error checking duplicate:", error);
      }
    }
  };
  const [getValue, setValue] = React.useState("1");
  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  //activity modal
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const allowedRoles = ["3", "7", "8", "9"]; // ใส่ role_id ที่อนุญาต
  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={getValue}>
        <Box
          sx={{
            borderBottom: 3,
            borderColor: "rgb(0, 120, 212)",
            paddingTop: 1,
          }}
        >
          <TabList
            onChange={handleChangeTab}
            sx={{
              "& .Mui-selected": {
                backgroundColor: "rgb(0, 120, 212)",
                color: "white",
                " &.css-3gr6th-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                  color: "white",
                },
                " &.css-t373k1.Mui-selected": { color: "white" },
              },
            }}
          >
            <Tab label="Customer & Activity timeline" value="1" />
            <Tab label="Last Shipment" value="2" />
            <Tab label="Service Usage" value="3" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Container maxWidth="xl">
            <Grid container spacing={2}>
              <Grid container spacing={2}>
                <br />
                <br />
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <label className="head">Customer Profile</label>
                </Grid>
                <Grid item xs={12} sm={4}></Grid>
                <Grid
                  item
                  xs={12}
                  sm={2}
                  style={{ display: "flex" }}
                  justify="flex-end"
                >
                  {id > 0 && (
                    <Button
                      type="button"
                      fullWidth
                      variant="contained"
                      className="addBtn"
                      color="primary"
                      onClick={handleOpenModal}
                    >
                      {allowedRoles.includes(getUserRole) ? (
                        <div> Create Follow-up Task</div>
                      ) : (
                        // โชว์กรณี role ไม่อยู่ใน allowedRoles
                        <div> New Activity</div>
                      )}
                    </Button>
                  )}
                  <AddActivityModal
                    key={Date.now()}
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    CUSTOMER_CODE={id}
                    ROLE_ID={getUserRole}
                    PAGE="FORM"
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <MainContactForm
                  CUSTOMER_CODE={id}
                  //SALES_ID={salesId}
                  // 👇 ถ้ามี SELECT_SALES_ID ให้ใช้ค่านั้นแทน salesId เดิม
                  SALES_ID={selectedSales.SELECT_SALES_ID ?? ""}
                  SALES_NAME={selectedSales.SELECT_SALESNAME ?? ""}
                  onCheckDuplicate={checkDuplicateName}
                  onCheckDuplicateTax={checkDuplicateTax}
                  isDuplicate={isDuplicate}
                  isDuplicateTax={isDuplicateTax}
                  onSend={setSharedValue}
                />
                <CustomerSalesIncharge
                  CUSTOMER_CODE={id}
                  onEdit={({ SELECT_SALES_ID, SELECT_SALESNAME }) => {
                    console.log(
                      "ค่าที่ส่งไป:",
                      SELECT_SALES_ID,
                      SELECT_SALESNAME
                    );
                    // อัพเดต state selectedSales
                    setSelectedSales({ SELECT_SALES_ID, SELECT_SALESNAME });
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                {!id && (
                  <CustomerDuplicateDatagrid
                    USER_ROLE={getUserRole}
                    data={duplicateData}
                    keyword={searchKeyword}
                  />
                )}
                {!id && (
                  <CustomerLastShipmentByCustomer
                    CUSTOMER_NAME={searchKeyword}
                  />
                )}
                {smf_code && !id && (
                  <CustomerShipperLoadDatagrid SMF_CODE={smf_code} />
                )}
                {smf_code && !id && (
                  <CustomerLastShipment SMF_CODE={smf_code} />
                )}
                {/* {id && ( */}
                <Box sx={{ maxHeight: 1000, overflow: "auto" }}>
                  <CustomerActivityTimeline
                    CUSTOMER_CODE={id}
                    USER_ID={getUserID}
                    EMP_CODE={getEmpCode}
                    USER_ROLE={getUserRole}
                  />
                </Box>
                {/* )} */}
              </Grid>
            </Grid>
          </Container>
        </TabPanel>
        <TabPanel value="2">
          <Container maxWidth="xl">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                {smf_code && <CustomerLastShipment SMF_CODE={smf_code} />}
              </Grid>
            </Grid>
          </Container>
        </TabPanel>
        {/* <TabPanel value="3">
          <Container maxWidth="xl">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                {smf_code && (
                  <CustomerShipperLoadDatagrid SMF_CODE={smf_code} />
                )}
              </Grid>
            </Grid>
          </Container>
        </TabPanel> */}
        <TabPanel value="3">
          <Container maxWidth="xl">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                {id > 0 && <CustomerServiceUsage CRM_CUSCODE={id} />}
              </Grid>
            </Grid>
          </Container>
        </TabPanel>
      </TabContext>
    </Box>
  );
}
